<template>
  <dv-full-screen-container>
    <!--头部开始-->
    <el-row style="height: 10%">
      <el-col :xl="24" :lg="24" :md="24" :sm="24" :sx="24" style="height: 100%">
        <div class="header1 header">
          <div class=" header_time">
            <span class="year">{{ date }}</span>
            <span class="hour" style="margin-left: 10px">{{ time }}</span>
          </div>
          <div class="header_left_nav">
            <router-link to="/">
              <button class="butt ">首页</button>
            </router-link>
          </div>
          <div class="header_left_nav nav1" style="z-index: 100000000">
            <router-link to="/Arrondi" >
              <button class="butt zq">专区</button>
            </router-link>
          </div>
          <div class=" header_title">
            <div class="header_img">
              <img src="../public/images/tixing.png" alt="">
              <div class="header_title_msg" style="left: 36%">
                帮扶专柜
              </div>
            </div>
          </div>
          <div class=" nav2 " style="z-index: 100000000">
            <router-link to="/Special" >
              <button class="butt ">专馆</button>
            </router-link>
          </div>
          <div class=" nav3">
            <router-link to="/SpecialCoun" >
              <button class="butt ">专柜</button>
            </router-link>
          </div>
          <div class=" nav5">
            <router-link to="/Information" >
              <button class="butt" >数据</button>
            </router-link>
          </div>
          <div class=" nav4">
            <button class="butt" v-on:click="login_out">退出</button>
          </div>
          <div class="clear-both"></div>
        </div>
      </el-col>
    </el-row>
    <!--头部完毕-->
    <el-row style="height: 45%">
      <el-col :span="8" style="height: 100%">
        <dv-border-box-1>
          <div class="title_msg">专柜消费排行</div>
          <div style="height: 87%">
            <ZGist1 msg="实时" style="padding: 0 3%; width: 94%; height: 100%"/>
          </div>
        </dv-border-box-1>
      </el-col>

      <el-col :span="8" style="height: 100%">
        <div class="title_msg">专柜热力图</div>
        <div style="height: 90%">
          <Map3 msg="实时" style="padding: 0 3%; width: 94%; height: 100%"/>
        </div>
      </el-col>
      <el-col :span="8" style="height: 100%">
        <el-col :span="24" style="height: 20%">
          <dv-border-box-1>
            <el-card class="box-card " >
              <div class="sales_data_box">
                <div v-for="(v,k,i) in sales_data" :key="i" class="text item sales_data">
                  <p class="sales_data_v"><animate-number from="100" :to="v.value" :key="v.value" duration="1000"></animate-number> </p>
                  <p class="sales_data_n">{{v.name}}<span></span> </p>
                </div>
              </div>
              <div class="clear-both"></div>
            </el-card>
          </dv-border-box-1>
        </el-col>
        <el-col :span="24" style="height: 75%; margin-top: 4%">

          <dv-border-box-1>
            <div class="title_msg">专柜地区排行</div>
            <div style="height: 78%; margin-top: 2%">
              <ZGRanking2 msg="实时" style="padding: 0 3%; width: 94%; height: 100%"/>
            </div>
          </dv-border-box-1>
        </el-col>
      </el-col>
    </el-row>
    <el-row style="height: 40%;margin-top: 1.7%">
      <el-col :span="8" style="height: 100%;">
        <dv-border-box-1>
          <div class="title_msg">消费数据对比图</div>
          <div style="height: 83%; margin-top: 1%">
            <ZGGalleries msg="专馆消费帮扶排行" style="padding: 0 3%; width: 94%; height: 100%"/>
          </div>
        </dv-border-box-1>
      </el-col>
      <el-col :span="16" style="height: 100%;">
        <dv-border-box-1>
          <div class="title_msg">专柜消费实时数据</div>
          <div style="height: 90%; margin-top: 1%">
            <ZGuConsumption msg="专馆消费帮扶排行" style="padding: 0 3%; width: 94%; height: 90%"/>
          </div>
        </dv-border-box-1>
      </el-col>
    </el-row>
  </dv-full-screen-container>
</template>

<script>

import Map3 from '@/views/map/Map3.vue'
import ZGist1 from '@/views/zhuangui/ZGist1.vue'
import ZGuConsumption from '@/views/zhuangui/ZGuConsumption.vue'
import ZGRanking2 from '@/views/ranking/ZGRanking2.vue'
import ZGGalleries from '@/views/zhuangui/ZGGalleries.vue'

export default {
  name: "Special",
  data() {
    return {
      sales_data: [
        {
          name:"销售总额",
          value:'',
        },
        {
          name:"帮扶总额",
          value:'',
        },
        {
          name:"专柜个数",
          value:'',
        },
      ],
    }
  },
  components: {
    Map3,
    ZGist1,
    ZGRanking2,
    ZGGalleries,
    ZGuConsumption
  },
  created(){

    let user_id = window.localStorage.getItem('user_id');

    // if (!user_id)
    // {
    //   this.$router.push({ path: '/Login' })
    //
    //   return false;
    // }

    const data = {
      'user_id': user_id
    };
    this.$api.zgu_summary(data).then(res=>
    {
      this.sales_data = res;
    })

    var that = this;
    var timerID = setInterval(updateTime, 1000);
    updateTime();

    function updateTime() {
      var cd = new Date();
      that.time = zeroPadding(cd.getHours(), 2) + ':' + zeroPadding(cd.getMinutes(), 2) + ':' + zeroPadding(cd.getSeconds(), 2);
      that.date = zeroPadding(cd.getFullYear(), 4) + '-' + zeroPadding(cd.getMonth()+1, 2) + '-' + zeroPadding(cd.getDate(), 2);
    };

    function zeroPadding(num, digit) {
      var zero = '';
      for(var i = 0; i < digit; i++) {
        zero += '0';
      }
      return (zero + num).slice(-digit);
    }

  },
  methods: {
    login_out:function(e){
      window.localStorage.clear();
      this.$notify({
        title: '成功',
        message: '退出登录',
        type: 'success'
      });
      this.$router.push({ path: '/Login' })
    }
  }
}
</script>

<style lang="less" scoped>
@import '../public/less/public/list.less';
@import '../public/less/zhuanguan/zhuanguan.less';
</style>